export const getErrorMessage = (error: unknown): string => {
  if (typeof error === "string") return error;
  if (error instanceof Error) return error.message;
  return "Có lỗi xảy ra, vui lòng thử lại";
};
